export const getVideoListViewStyle = () => ({
  root: {
    '& .cancel-upload-button-container': {
      display: 'flex',
      justifyContent: 'center',
      marginTop: 4,
      '& button': {
        height: 24,
        minWidth: 56,
        width: 56,
      },
    },
  },
});
